import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  useLazyGetAgroTrackingForecastDetailedViewVariablesQuery,
} from 'services/api/Meteorology/Agro/TrackingForecast/DetailedView';
import {
  selectDVCPMATrackingForecastSubpage,
  selectDVCPMATrackingForecastTimeFrequency,
  selectDVCPMATrackingForecastLocationId,
  selectDVCPMATrackingForecastForecastDate,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';

export default function useVariableOptions() {
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];
  const timeFrequency = useSelector(selectDVCPMATrackingForecastTimeFrequency);
  const locationId = useSelector(selectDVCPMATrackingForecastLocationId);
  const forecastDate = useSelector(selectDVCPMATrackingForecastForecastDate);

  const [trigger, {
    data, isFetching,
  }] = useLazyGetAgroTrackingForecastDetailedViewVariablesQuery();

  const coreFields = useMemo(() => Boolean(timeFrequency), [timeFrequency]);

  const variables = useMemo(() => {
    if (!data) return [];
    return coreFields ? data : [];
  }, [coreFields, data]);

  useEffect(() => {
    if (coreFields) {
      trigger({
        submenu,
        timeFrequency,
        modelIds: [1],
        forecastDate,
        locationId,
      });
    }
  }, [
    submenu, timeFrequency, coreFields, trigger, forecastDate, locationId,
  ]);

  return { variables, isFetching };
}
